import { addEventListener } from '../../browser/addEventListener';
import { combine } from '../../tools/mergeInto';
import { isEmptyObject } from '../../tools/utils/objectUtils';
var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
export function storeContextManager(configuration, contextManager, productKey, customerDataType) {
  var storageKey = buildStorageKey(productKey, customerDataType);
  storageListeners.push(addEventListener(configuration, window, "storage"
  /* DOM_EVENT.STORAGE */
  , function (_ref) {
    var key = _ref.key;

    if (storageKey === key) {
      synchronizeWithStorage();
    }
  }));
  contextManager.changeObservable.subscribe(dumpToStorage);
  var contextFromStorage = combine(getFromStorage(), contextManager.getContext());

  if (!isEmptyObject(contextFromStorage)) {
    contextManager.setContext(contextFromStorage);
  }

  function synchronizeWithStorage() {
    contextManager.setContext(getFromStorage());
  }

  function dumpToStorage() {
    localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
  }

  function getFromStorage() {
    var rawContext = localStorage.getItem(storageKey);
    return rawContext ? JSON.parse(rawContext) : {};
  }
}
export function buildStorageKey(productKey, customerDataType) {
  return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
export function removeStorageListeners() {
  storageListeners.map(function (listener) {
    return listener.stop();
  });
}